import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import {
  change,
  submit as submitForm,
  formValueSelector,
  reduxForm,
} from "redux-form";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import { flowRight as compose } from 'lodash';
import moment from 'moment';

import CustomPagination from "../CustomPagination";
import NoResults from "../NoResults";
import PriceDetailsModal from "../ListingItem/PriceDetailsModal";
import InfiniteScrollResults from "./InfiniteScrollResults";
import ShowOneTotalPrice from "../Filters/ShowOneTotalPrice/ShowOneTotalPrice";
import ListingItemsData from "./ListingItemsData";

import submit from "../SearchForm/submit";
import { showMap } from "../../../actions/mobileSearchNavigation";
import { searchPagination, searchLimit } from "../../../config";

import messages from "../../../locale/messages";
import cs from '../../../components/commonStyle.css';
import s from "./SearchResults.css";

class SearchResults extends React.Component {
  static propTypes = {
    change: PropTypes.any,
    submitForm: PropTypes.any,
    results: PropTypes.array,
    currentPage: PropTypes.number,
    total: PropTypes.number,
    isResultLoading: PropTypes.bool,
    personalized: PropTypes.shape({
      isOneTotalToggle: PropTypes.bool,
    }),
  };

  static defaultProps = {
    results: [],
    showMap: false,
    showMapLoader: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const { currentPage } = this.props;
    if (currentPage != undefined) {
      this.setState({ page: currentPage });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { currentPage } = nextProps;
    if (currentPage != undefined) {
      this.setState({ page: currentPage });
    }
  }

  handlePagination = async (currentPage) => {
    const { change, handleSubmit } = this.props;
    await change("currentPage", currentPage);
    window.scrollTo({
      top: 0,
      left: 0
    });
    await handleSubmit();
  };

  handleSortByChange = async (event) => {
    const { change, handleSubmit } = this.props;
    await change("sortBy", event.target.value);
    await change("currentPage", 1);
    await handleSubmit();
  };

  formatSummaryDate = (date) => {
    if (!date) return null;
    const day = moment(date).format('D');
    const monthYear = moment(date).format('MMM YYYY');
    return `${day} ${monthYear}`;
  };

  render() {
    const { results, total, isResultLoading, showMapLoader, guests, isOneTotalToggle, searchCount, sortBy } = this.props;
    const { formatMessage } = this.props.intl;
    const { page } = this.state;

    const location = this.props?.personalized?.location;
    let startDate = this.props?.personalized?.startDate;
    let endDate = this.props?.personalized?.endDate;

    const formDates = this.props?.dates;
    if (formDates) {
      const parts = String(formDates).split('AND').map(part => part.replace(/'/g, '').trim());
      if (parts[0]) startDate = parts[0];
      if (parts[1]) endDate = parts[1];
    }

    const summaryParts = [];
    if (location && location.trim()) summaryParts.push(location.trim());
    if (startDate && endDate) summaryParts.push(`${this.formatSummaryDate(startDate)} – ${this.formatSummaryDate(endDate)}`);
    else if (startDate) summaryParts.push(this.formatSummaryDate(startDate));
    if (guests) summaryParts.push(`${guests} ${guests > 1 ? formatMessage(messages.guestsLabel) : formatMessage(messages.guestLabel)}`);

    if (!total) {
      return <NoResults location={location} />;
    } else {
      return (
        <div className={s.searchResults}>
         {/*  {isOneTotalToggle ? (
            <ShowOneTotalPrice
              className={cx(
                s.filterButtonContainer,
                s.hiddenResponsive,
                s.hideTabletSection
              )}
              handleTabToggle={this.handleTabToggle}
            />
          ) : (
            <></>
          )} */}

          <div className={cx(s.summaryRow, "summaryRowRTL")}>
            <div className={s.summaryCriteria}>
              {summaryParts.map((part, index) => (
                <span key={index} className={s.summaryDatum}>
                  {part}
                  {index < summaryParts.length - 1 && <span className={s.summarySeparator}>|</span>}
                </span>
              ))}
            </div>
            <div className={cx(s.sortWrap, cs.alignCenter)}>
              <span className={s.sortLabel}>
                <FormattedMessage {...messages.sortByLabel} />:
              </span>
              <select
                className={s.sortSelect}
                value={sortBy || 'recommended'}
                onChange={this.handleSortByChange}
              >
                <option value="recommended">
                  {formatMessage(messages.recommendedResults)}
                </option>
                <option value="mostBookings">
                  {formatMessage(messages.mostBookings)}
                </option>
              </select>
            </div>
          </div>

          {!showMapLoader && (
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                {isResultLoading && (
                  <div className={cx(s.loadingOverlay, "loadingOverlayDark")} />
                )}
                <PriceDetailsModal />
                {searchCount > searchPagination ? (
                  <ListingItemsData results={results} guests={guests} />
                ) : (
                  <InfiniteScrollResults results={results} guests={guests} />
                )}
              </Col>
            </Row>
          )}

          {searchCount > searchPagination && (
            <div className={s.resultsFooter}>
              <div className={s.resultsPagination}>
                <div className={s.pagination}>
                  <CustomPagination
                    total={total}
                    current={page}
                    defaultCurrent={1}
                    defaultPageSize={searchLimit}
                    handleChange={this.handlePagination}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
}

SearchResults = reduxForm({
  form: "SearchForm", // a unique name for this form
  onSubmit: submit,
  destroyOnUnmount: false,
})(SearchResults);

const selector = formValueSelector("SearchForm");

const mapState = (state) => ({
  results: state?.search?.data,
  currentPage: selector(state, "currentPage"),
  total: state?.search?.count,
  searchCount: state?.search?.searchCount,
  isResultLoading: state?.search?.isResultLoading,
  showMap: state?.personalized?.showMap,
  showMapLoader: state?.loader?.showMapLoading,
  guests: Number(selector(state, "personCapacity")),
  isOneTotalToggle: state?.personalized?.isOneTotalToggle,
  sortBy: selector(state, "sortBy"),
  personalized: state?.personalized,
  dates: selector(state, "dates"),
});

const mapDispatch = {
  change,
  submitForm,
  showMap,
};

export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState, mapDispatch)
)(SearchResults);
